import type { ViewFilters } from '@werft/contracts';

/**
 * Gespeicherte Ansicht anfordern (Palette, Übersicht) – getrennt von `ViewsBar`, damit Startmodule nur diesen kleinen
 * Teil laden (0.158, Startpaket).
 */
const requested = new Map<string, { id: string; filters: ViewFilters }>();
export function requestView(projectId: string, id: string, filters: ViewFilters) {
  requested.set(projectId, { id, filters });
  window.dispatchEvent(new CustomEvent('werft:view', { detail: { projectId, id, filters } }));
}
export function takeRequestedView(projectId: string) {
  const r = requested.get(projectId);
  requested.delete(projectId);
  return r;
}

